import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Date } from '@types';
import {
  PublicLayout,
  LegacyMap,
  Icon,
  SendButton,
  toast
} from '@components';

import resendUnusualAccessEmail from './api';
import './style.scss';

const UnusualAccessLock = props => {
  const [unusualAccessData, setUnusualAccessData] = useState({});

  const { state, history } = props;

  const hasValidCoordinates = coordinates => {
    const { latitude, longitude } = coordinates;
    const hasLatitude = Boolean(latitude);
    const hasLongitude = Boolean(longitude);

    return hasLatitude && hasLongitude;
  };

  const getUnusualAccessData = () => {
    const unusualAccessMetadata = state.get('unusualAccessData') || '{}';

    return JSON.parse(unusualAccessMetadata);
  };

  const clearUnusualAccessDataFromStorage = () => {
    state.remove('unusualAccessData');
  };

  const renderSuccessToast = message => {
    toast.success(
      <p>{message}</p>,
      {
        time: 5000,
        iconName: 'icCheckWhite',
        iconAlt: 'Mensaje de éxito'
      }
    );
  };

  const renderDangerToast = message => {
    toast.danger(
      <p>{message}</p>,
      {
        time: 5000,
        iconName: 'icSadFaceWhite',
        iconAlt: 'Mensaje de error'
      }
    );
  };

  const resendEmailUnusualAccess = async () => {
    try {
      await resendUnusualAccessEmail({ email: unusualAccessData.responseEmail });
      renderSuccessToast('El correo se envió con éxito');
    } catch (error) {
      renderDangerToast('Algo salió mal al enviar el correo, inténtalo de nuevo');
    }
  };

  const goToLogin = () => history.push('/login');

  useEffect(() => {
    const unusualAccessDataFromProps = getUnusualAccessData();

    setUnusualAccessData(unusualAccessDataFromProps);

    return () => clearUnusualAccessDataFromStorage();
  }, []);

  const { detectedAt, geolocalization = {} } = unusualAccessData;
  const { latitude, longitude } = geolocalization;
  const coordinates = { latitude, longitude };
  const formattedDetectedAtDate = new Date(detectedAt).format('DD MMMM YYYY');
  const formattedDetectedAtTime = new Date(detectedAt).format('hh:mm a');

  return (
    <PublicLayout title="Sesión inusual, cuenta bloqueada">
      <button
        id="go-back"
        tid="go-back"
        styleName="go-back"
        onClick={goToLogin}
        type="button"
      >
        <Icon name="icBackDark" alt="Regresar" />
        <p>Regresar</p>
      </button>
      <div styleName="content">
        <p styleName="text" tid="detected-at">
          Identificamos un inicio de sesión el
          {' '}
          {formattedDetectedAtDate}
          {' '}
          a las
          {' '}
          {formattedDetectedAtTime}
          ,
          {' '}
          <br />
          {' '}
          en una ubicación distinta a la habitual.
        </p>
        {
          hasValidCoordinates(coordinates) && (
            <div styleName="map">
              <LegacyMap coordinates={coordinates} tid="map" />
            </div>
          )
        }
        <p styleName="text" tid="support-text">
          Por seguridad hemos bloqueado esta cuenta, para desbloquearla
          <br />
          {' '}
          sigue las instrucciones que hemos enviado a tu correo electrónico
          {' '}
          <br />
          {' '}
          o
          puedes contactar con soporte a cliente.
        </p>
        <p styleName="support-email" tid="support-email">soporte@100Ladrillos.com</p>
        <span styleName="text">¿Aún no llega tu correo? Intenta enviarlo nuevamente</span>
        {/* TODO: Delete component */}
        <SendButton
          id="resend-email"
          tid="resend-email"
          handleSendByEmail={resendEmailUnusualAccess}
          isSendByEmailOnly
        />
      </div>
    </PublicLayout>
  );
};

UnusualAccessLock.propTypes = {
  state: PropTypes.shape({
    get: PropTypes.func.isRequired,
    remove: PropTypes.func.isRequired
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
};

export default UnusualAccessLock;
